"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var ArrowRight_1 = __importDefault(require("../Icons/ArrowRight/ArrowRight"));
var SyncSpinner_1 = require("../Icons/SyncSpinner/SyncSpinner");
var b2c_theme_1 = require("../Theme/b2c-theme");
var Typography_1 = __importStar(require("../Typography/Typography"));
var LinkElement = styled_components_1.default.a(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  color: ", ";\n  position: relative;\n  text-decoration: underline;\n  ", "\n  padding-right: ", ";\n  outline: none;\n  transition: box-shadow 0.1s ease-in-out;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none; /* Some users disable motion/animation */\n  }\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n    text-decoration: underline;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n    text-decoration: underline;\n  }\n\n  &:active {\n    color: ", ";\n  }\n"], ["\n  color: ", ";\n  position: relative;\n  text-decoration: underline;\n  ", "\n  padding-right: ", ";\n  outline: none;\n  transition: box-shadow 0.1s ease-in-out;\n\n  @media (prefers-reduced-motion: reduce) {\n    transition: none; /* Some users disable motion/animation */\n  }\n\n  &:hover {\n    color: ", ";\n    cursor: pointer;\n    text-decoration: underline;\n  }\n\n  &:focus {\n    box-shadow: 0 0 0 2px ", ";\n    text-decoration: underline;\n  }\n\n  &:active {\n    color: ", ";\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return b2c_theme_1.fontTheme[theme];
}, function (_a) {
    var block = _a.block;
    return block
        ? "\n        display: flex;\n        justify-content: space-between;\n        align-items: center;\n      "
        : 'display: inline-block;';
}, function (_a) {
    var includeNextIcon = _a.includeNextIcon;
    return includeNextIcon ? 'calc(24px + 10px + 1rem)' : '0';
}, function () { return b2c_theme_1.colors.primaryFontColor; }, b2c_theme_1.colors.primaryColor, function () { return b2c_theme_1.colors.primaryFontColor; });
var IconWrapper = styled_components_1.default.i(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  top: calc(50% - 12px);\n  border: 1px solid ", ";\n  width: 24px;\n  height: 24px;\n  padding: 0.4rem 0.5rem 0.4rem;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-left: 1rem;\n"], ["\n  position: absolute;\n  right: 10px;\n  top: calc(50% - 12px);\n  border: 1px solid ", ";\n  width: 24px;\n  height: 24px;\n  padding: 0.4rem 0.5rem 0.4rem;\n  border-radius: 50%;\n  vertical-align: middle;\n  margin-left: 1rem;\n"])), b2c_theme_1.colors.iconBorder);
var PreIconWrapper = styled_components_1.default.i(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-right: 0.8rem;\n"], ["\n  vertical-align: middle;\n  margin-right: 0.8rem;\n"])));
var PostIconWrapper = styled_components_1.default.i(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  vertical-align: middle;\n  margin-left: 0.8rem;\n"], ["\n  vertical-align: middle;\n  margin-left: 0.8rem;\n"])));
var Link = react_1.default.forwardRef(function (props, ref) {
    var defaultProps = {
        block: false,
        bold: false,
        caps: false,
        disabled: false,
        includeNextIcon: false,
        semibold: false,
        textAlign: 'inherit',
        textComponent: Typography_1.TypeVariants.span,
        textTheme: 'primary',
        textVariant: Typography_1.TypeVariants.body,
    };
    var _a = __assign(__assign({}, defaultProps), props), block = _a.block, bold = _a.bold, caps = _a.caps, disabled = _a.disabled, iconColor = _a.iconColor, includeNextIcon = _a.includeNextIcon, onClick = _a.onClick, padding = _a.padding, postIcon = _a.postIcon, preIcon = _a.preIcon, semiBold = _a.semiBold, targetBlank = _a.targetBlank, text = _a.text, textAlign = _a.textAlign, textComponent = _a.textComponent, textTheme = _a.textTheme, textVariant = _a.textVariant, to = _a.to, rest = __rest(_a, ["block", "bold", "caps", "disabled", "iconColor", "includeNextIcon", "onClick", "padding", "postIcon", "preIcon", "semiBold", "targetBlank", "text", "textAlign", "textComponent", "textTheme", "textVariant", "to"]);
    var _b = react_1.default.useState(SyncSpinner_1.IconColorThemes.default), iconColorTheme = _b[0], setIconColorTheme = _b[1];
    react_1.default.useEffect(function () {
        if (disabled) {
            setIconColorTheme(SyncSpinner_1.IconColorThemes.default);
            return;
        }
        if (iconColor) {
            setIconColorTheme(iconColor);
        }
        else if (textTheme) {
            switch (textTheme) {
                case 'white':
                    setIconColorTheme(SyncSpinner_1.IconColorThemes.white);
                    break;
                default:
                    setIconColorTheme(SyncSpinner_1.IconColorThemes.default);
                    break;
            }
        }
    }, [iconColor, textTheme, disabled]);
    return (react_1.default.createElement(LinkElement, __assign({ block: block, "data-testid": "link-element", href: to, includeNextIcon: includeNextIcon, onClick: onClick, ref: ref, rel: targetBlank ? 'noopener noreferrer' : '', target: targetBlank ? '_blank' : '', theme: textTheme }, rest),
        preIcon && (react_1.default.createElement(PreIconWrapper, null, react_1.default.cloneElement(preIcon, {
            size: b2c_theme_1.IconSizes.small,
            color: iconColorTheme,
        }))),
        react_1.default.createElement(Typography_1.default, { align: textAlign, allCaps: caps, bold: bold, variant: textVariant, component: textComponent, padding: padding, semiBold: semiBold, theme: textTheme, dangerouslySetInnerHTML: { __html: text }, style: {
                width: '100%',
            } }),
        !includeNextIcon && postIcon && (react_1.default.createElement(PostIconWrapper, null, react_1.default.cloneElement(postIcon, {
            size: b2c_theme_1.IconSizes.small,
            color: iconColorTheme,
        }))),
        includeNextIcon && (react_1.default.createElement(IconWrapper, null,
            react_1.default.createElement(ArrowRight_1.default, { size: b2c_theme_1.IconSizes.xSmall })))));
});
exports.default = Link;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Link.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Link/Link.js
// module id = 481
// module chunks = 81